class ProductForm extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    if (!this.form){return;}
    this.form.addEventListener('submit', (e) => this.onSubmit(e));
  }

  onSubmit(e) {
    e.preventDefault();

    const formData = new FormData(this.form);
    const button = this.form.querySelector('[type="submit"]');
    if (button.disabled) return; // tránh double-click khi đang xử lý
    button.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: { 'Accept': 'application/json' },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status) {
          throw new Error(data.description || 'Could not add to cart');
        }

        // change to icon checked
        button.classList.add('is-added');

        // update cart and sup number
        return fetch('/cart.js').then((res) => res.json());
      })
      .then((cart) => {
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart, bubbles: true }));
    })
      .catch((err) => {
         console.error('ERROR CAUGHT:', err); 
      })
      .finally(() => {
        setTimeout(() => {
          button.classList.remove('is-added');
          button.disabled = false;
        }, 2000); // đúng 2s theo yêu cầu
      });
  }
}

customElements.define('product-form', ProductForm);